/**
 * Последний показанный ответ экрана — в памяти, на время жизни вкладки/WebView.
 *
 * Правка Ирины 02.10 («экраны при переходе по вкладкам и при открытии уведомлений
 * вздрагивают»). Каждая вкладка нижней навигации (Лента, Сообщения, Куда сходить)
 * и окно уведомлений держали данные в локальном state компонента. Смена вкладки
 * размонтирует страницу, и на возврате она стартовала с `loading=true`: на месте
 * уже виденного контента на 150–300 мс (время ответа API) вставал спиннер или
 * «Загрузка…», после чего контент выскакивал заново. Покадрово (Chromium, Android
 * WebView UA, CPU×4) это и есть «вздрагивание».
 *
 * Теперь экран при повторном монтировании сразу рисует последний ответ и тихо
 * перечитывает данные в фоне (stale-while-revalidate). Индикатор загрузки остался
 * только для самого первого захода, когда показывать ещё нечего.
 *
 * Записи привязаны к владельцу (id пользователя): чужой ответ не покажется даже при
 * смене аккаунта без перезагрузки. Плюс AuthProvider чистит весь кэш при выходе.
 */
type Entry = {owner: string; value: unknown; at: number};

const store = new Map<string, Entry>();

export function readScreenCache<T>(key: string, owner: string | number | null | undefined): {value: T; at: number} | null {
    if (owner == null) return null;
    const entry = store.get(key);
    if (!entry || entry.owner !== String(owner)) return null;
    return {value: entry.value as T, at: entry.at};
}

export function writeScreenCache<T>(key: string, owner: string | number | null | undefined, value: T): void {
    if (owner == null) return;
    store.set(key, {owner: String(owner), value, at: Date.now()});
}

export function dropScreenCache(keyPrefix: string): void {
    for (const key of [...store.keys()]) {
        if (key.startsWith(keyPrefix)) store.delete(key);
    }
}

export function clearScreenCache(): void {
    store.clear();
}

export const SCREEN_CACHE_KEYS = {
    feed: "feed",
    chats: "chats",
    notifications: "notifications",
    places: (city: string) => `places:${city}`,
} as const;
